import { render, staticRenderFns } from "./goods-taking.vue?vue&type=template&id=ffe12c78&scoped=true&"
import script from "./goods-taking.vue?vue&type=script&lang=js&"
export * from "./goods-taking.vue?vue&type=script&lang=js&"
import style0 from "./goods-taking.vue?vue&type=style&index=0&id=ffe12c78&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffe12c78",
  null
  
)

export default component.exports